import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import { featuredArticles, latestArticles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import { siteInfo } from "@/mocks/site";

function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20editorial%20photography%20with%20beautiful%20Asian%20woman%20in%20flowing%20dress%20surrounded%20by%20soft%20blooming%20flowers%2C%20warm%20golden%20hour%20lighting%2C%20dreamy%20pastel%20color%20palette%2C%20luxury%20magazine%20cover%20style%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field&width=1800&height=900&seq=hero-bg-home&orientation=landscape"
        alt="美女网站精选推荐 - 高颜值内容聚合平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <p className="text-background-100/90 text-sm md:text-base tracking-widest mb-4 uppercase">
          发现美 · 欣赏美 · 分享美
        </p>
        <h1
          className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          美女网站精选推荐
          <br />
          <span className="text-2xl md:text-3xl lg:text-4xl font-normal">
            高颜值内容聚合平台
          </span>
        </h1>
        <p className="text-background-200/90 text-sm md:text-base max-w-2xl leading-relaxed">
          精选全网高质量美女写真、时尚穿搭、美妆教程与生活方式内容。每日更新，严格筛选，为爱美人士提供最优质的视觉体验与时尚资讯。
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <Link
            to="/category/meinv-xiezhen"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            探索精彩内容
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium whitespace-nowrap hover:bg-background-50/30 transition-colors"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}

function StatsBar() {
  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 py-6 md:py-8">
          {[
            { value: siteInfo.stats.articles, label: "精选文章" },
            { value: siteInfo.stats.categories, label: "内容分类" },
            { value: siteInfo.stats.totalViews, label: "累计浏览量" },
            { value: siteInfo.stats.subscribers, label: "订阅用户" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-500" style={{ fontFamily: "var(--font-heading)" }}>
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CategorySection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
            内容分类
          </h2>
          <p className="text-foreground-500 text-sm mt-2">探索你感兴趣的精彩内容</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 mt-1">
                {cat.count}篇
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturedSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
            精选推荐
          </h2>
          <Link
            to="/category/meinv-xiezhen"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs rounded-full whitespace-nowrap">
                  {article.categoryName}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors" style={{ fontFamily: "var(--font-heading)" }}>
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function LatestSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
            最新发布
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestArticles.slice(0, 8).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4">
                <span className="text-xs text-accent-500 font-medium mb-1 block">
                  {article.categoryName}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors" style={{ fontFamily: "var(--font-heading)" }}>
                  {article.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-line"></i> {article.likes}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20elegant%20abstract%20background%20with%20gentle%20gradient%20of%20warm%20rose%20and%20cream%20tones%2C%20delicate%20floral%20texture%2C%20luxury%20cosmetic%20brand%20aesthetic%2C%20soft%20focus%2C%20dreamy%20atmosphere&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/70 to-foreground-900/40"></div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
          加入我们的美丽社区
        </h2>
        <p className="text-background-200 text-sm md:text-base max-w-xl mx-auto mb-8">
          订阅我们的内容，第一时间获取最新美女写真、时尚穿搭和美妆教程推送
        </p>
        <Link
          to="/about"
          className="inline-block px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
        >
          了解更多
        </Link>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            potentialAction: {
              "@type": "SearchAction",
              target: `${siteInfo.url}/search?q={search_term_string}`,
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            email: siteInfo.email,
            telephone: siteInfo.phone,
            address: {
              "@type": "PostalAddress",
              streetAddress: siteInfo.address,
              addressCountry: "CN",
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <StatsBar />
          <CategorySection />
          <FeaturedSection />
          <LatestSection />
          <CTASection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}